import { LogData, LoggingService } from '@/services/api/logging'
import { PublishDeveloperReportEvent } from '@/usecases/event-bus-for-third-party/event'
import { DeveloperReportThrottle } from './handle-publish-developer-reports/developer-report-throttle'

const throttle = new DeveloperReportThrottle()

/**
 * 開発者用の一般的な出力(ログなど)を扱うイベント
 *
 * 現在はサードパーティを利用していないが、将来的にそちらに代替する可能性あり。
 * 今後、以下のリンク先のように機能を増強する予定。
 * @see https://github.com/Everforth/growthpalette-front/issues/7848#issuecomment-1903342440
 */
export function handlePublishDeveloperReports(events: PublishDeveloperReportEvent[]): void {
  const filtered = throttle.filter(events)
  // 空の logs はサーバ側(LoggingApiController)が BadRequest にするため、送らない
  if (filtered.length === 0) {
    return
  }

  sendReportsToServer(filtered)
}

function sendReportsToServer(events: PublishDeveloperReportEvent[]): void {
  const payload = convertToLoggingAPIFormat(events)

  const loggingService = new LoggingService()
  loggingService.post(payload)
}

function convertToLoggingAPIFormat(events: PublishDeveloperReportEvent[]): LogData[] {
  return events.map((e) => {
    return {
      level: e.level,
      message: JSON.stringify({
        content: e.message,
        reportSource: e.reportSource,
        timestamp: e.timestamp.toISOString(),
        // undefined のときは JSON.stringify がキーごと落とすので、有無の条件分岐は不要
        metaMessages: e.metaMessages,
      }),
    }
  })
}
